// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___3nRH8","initials":"styles__initials___3OwPw"};